import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './auth/auth.guard';
import { LoginComponent } from './auth/login/login.component';
import { DashboardComponent } from './dashboard/dashboard.component';
 

const routes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: 'checkpoints-process', component: DashboardComponent, canActivate: [AuthGuard] },
  { path: '', redirectTo: 'checkpoints-process', pathMatch: 'full' },
  { path: '**', redirectTo: '' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
